module.exports = __webpack_public_path__ + "static/apps-f50aa495aad8af0989602bcc7946b012.png";